import React from "react";
import { SexIcon, AgeIcon, GoalIcon, ExperienceIcon, WorkoutIcon, TimeIcon, IntensityIcon } from "./Icons";

const iconComponents = [SexIcon, AgeIcon, GoalIcon, ExperienceIcon, WorkoutIcon, TimeIcon, IntensityIcon];

const ProgressBar = ({ currentStep }) => {
  return (
    <div className={`icon-container ${currentStep === -1 ? "opacity-0 negative-margin" : "progress-margin"}`}>
      {Array.from({ length: iconComponents.length }, (_, index) => {
        const IconComponent = iconComponents[index];
        return (
          <div key={index} className={`icon ${index === currentStep ? "current" : index < currentStep ? "completed" : ""} `}>
            <IconComponent />
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
